module.exports = __webpack_public_path__ + "static/media/Launch.fe58290e.png";